import { isNull } from "__barrel_optimize__?names=isNull!=!lodash-es";
/**
 * [getUrlParam 获取url变量]
 * @param  {[string]} _paramName [需获取变量的名称]
 * @param  {[string]} _url       [给出需要获取的url，默认为当前页面url] 可选
 * @return {[string]}            [返回获取到的变量值]
 */
export function getUrlParam(_paramName, _url) {
  const reg = new RegExp("(^|&)".concat(_paramName, "=([^&]*)(&|$)"), "i");
  let url = _url || window.location.href;
  if (url && url.replace) {
    url = url.replace("#/", "").toString();
    const r = ((url ? url.split("?")[1] : encodeURI(window.location.search).substr(1)) || "").match(reg);
    if (!isNull(r)) return unescape(r[2]);
  }
  return null;
}
/**
 * 处理 XSS 注入
 *
 * @export
 * @param {string} value
 * @returns
 */
export function escapeHtml(_value) {
  let thisVal = _value;
  const regStr = /[<>`"'\/]/g; // /[&<>`"'\/]/g
  if (_value && typeof _value.match === "function" && _value.match(regStr)) {
    thisVal = _value.replace(regStr, str => {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        "`": "&#x60;",
        '"': "&quot;",
        "'": "&#x27;",
        "/": "&#x2f;"
      }[str];
    });
  }
  return thisVal;
}
/**
 * [将被转化过 < / > 的还原]
 *
 * @export
 * @param {string} _content
 */
export function reverseEscapeHtml(_content) {
  let thisVal = _content;
  const regStr = /&lt;|&gt;|&#x2f;/g;
  if (_content && _content.match(regStr)) {
    thisVal = thisVal.replace(regStr, str => {
      return {
        "&lt;": "<",
        "&#x2f;": "/",
        "&gt;": ">"
      }[str];
    });
  }
  return thisVal;
}
/**
 * [判断环境浏览器]
 *
 * @export
 */
export function getBrowserOs() {
  // var OsObject = "";
  if (navigator.userAgent.indexOf("MSIE") > 0) {
    return "MSIE";
  } else if (navigator.userAgent.indexOf("Firefox") > 0) {
    return "Firefox";
  } else if (navigator.userAgent.indexOf("Opera") > 0) {
    //这个也被判断为chrome
    return "Opera";
  } else if (navigator.userAgent.indexOf("Chrome") > 0) {
    return "Chrome";
  } else if (navigator.userAgent.indexOf("Safari") > 0) {
    return "Safari";
  } else if (navigator.userAgent.indexOf("Camino") > 0) {
    return "Camino";
  } else if (navigator.userAgent.indexOf("Gecko/") > 0) {
    return "Gecko";
  }
  return "Chrome";
}
/**
 * @description 从对象中提取字段组成新对象
 * @param records 提取目标
 * @param keys 提取的字段数组
 * @returns
 */
export function fieldsExtract(records, keys) {
  const result = {};
  for (let key of keys) {
    if (Object.hasOwn(records, key)) {
      result[key] = records[key];
    }
  }
  return result;
}